export default [
  {
    title: 'CDN',
    gjIcon: 'Grid',
    children: [
      {
        title: 'Analytics',
        route: 'analytics',
        action: 'read',
        resource: 'analytics',
      },
      {
        title: 'Distributions',
        route: 'distributions',
      },
      {
        title: 'Policies',
        route: 'cache-policies',
      },
    ],
  },
]
